export const MikeVisualizerContainer = (props: any) => {
  return (
    <div
      style={{
        width: props.sidePanelOpen ? 'calc(100vw - 400px)' :'100vw', 
        height: 'calc(100vh - 60px)',
        display: 'flex',  
        boxSizing: 'border-box'
      }}
    >
      <div
        style={{
          position: 'relative',
          zIndex: 2,     
          width: '100vw', 
          height: '60vh',    
          margin: '0px',
          boxSizing: 'border-box',
          boxShadow: 'rgba(0, 0, 0, 0.16) -8px 1px 10px, rgba(0, 0, 0, 0.1) -8px 1px 20px',
          ...props.style,
        }}
      >
        {props.children}
      </div>
    </div>
  );
};

export const MikeVisualizerStoryDetails = (props: any) => {
  return (
    <div
      style={{
        overflow: 'auto',       
        height: '33vh', 
        margin: '0px',
        background: 'white',        
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
};
